module.exports = __webpack_public_path__ + "static/media/skip_button.3a790c55.png";